import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface DoughnutChartProps {
    data: number[];
    labels: string[];
    colors: string[];
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({ data, labels,colors }) => {
    // const colors = ['#0CB99D', '#EDF0F5']
    const chartOptions = {
        chart: {
            fontFamily: "Sora, system-ui, sans-serif",
            foreColor: "#627771",
        },
        labels: labels,
        dataLabels: {
            enabled: false 
        },
        legend: {
            show: false 
        },
        colors: colors, 
        fill: { type: 'solid' },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%'
                }
            }
        },
        stroke: {
            width: 0 // Remove the stroke (border) around the doughnut
        },
    };

    const chartSeries = data;

    return (
        <div role="img" aria-label={`${labels[0] || "Rating"}: ${data[0] || 0} out of ${(data[0] || 0) + (data[1] || 0)}`}>
            <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={250} />
            
        </div>
    );
};

export default DoughnutChart;
